/* Mood Rise · Sombere Gevoelens · Landing Page
 * Gallery, bundle selector, Ajax add-to-cart, FAQ, reveals, smooth scroll.
 * Compatible with Broadcast theme (Vitasonar) — uses theme:product:added event
 * to open the cart drawer after a successful add.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // -----------------------------------------------------------------
  // Gallery — swipable scroll-snap carousel + thumbnail strip
  // Thumb click scrolls the main carousel to that slide; scrolling the main
  // carousel updates the active thumb via IntersectionObserver.
  // -----------------------------------------------------------------
  function initGallery() {
    var mainHolder = document.querySelector('[data-mrlp-main-image]');
    if (!mainHolder) return;
    var slides = mainHolder.querySelectorAll('[data-mrlp-slide-index]');
    var thumbs = document.querySelectorAll('[data-mrlp-thumb]');

    function setActiveByIndex(idxStr) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-mrlp-thumb-index') === idxStr);
      });
    }

    // Thumb click → smooth-scroll the main carousel to the matching slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-mrlp-thumb-index');
        var slide = mainHolder.querySelector('[data-mrlp-slide-index="' + idx + '"]');
        if (slide) {
          mainHolder.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        setActiveByIndex(idx);
      });
    });

    // Swipe / scroll on main carousel → update active thumb
    if ('IntersectionObserver' in window && slides.length) {
      var io = new IntersectionObserver(function (entries) {
        // Pick the entry with the highest intersection ratio
        var best = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
            best = entry;
          }
        });
        if (best) {
          setActiveByIndex(best.target.getAttribute('data-mrlp-slide-index'));
        }
      }, { root: mainHolder, threshold: [0.5, 0.75] });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  // -----------------------------------------------------------------
  // Bundle selector — radio behavior + price reflection on CTA
  // -----------------------------------------------------------------
  function getSelectedBundle() {
    return document.querySelector('[data-mrlp-bundle].is-selected');
  }

  function formatPriceCents(cents) {
    var n = parseInt(cents, 10);
    if (!isFinite(n)) return '';
    var euros = (n / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  function syncCtaPrice() {
    var sel = getSelectedBundle();
    var priceEl = document.querySelector('[data-mrlp-cta-price]');
    if (!priceEl || !sel) return;
    var cents = sel.getAttribute('data-mrlp-price-cents');
    priceEl.textContent = formatPriceCents(cents);
  }

  function initBundles() {
    var bundles = document.querySelectorAll('[data-mrlp-bundle]');
    if (!bundles.length) return;

    // Make sure exactly one is selected on init
    var anySelected = Array.from(bundles).some(function (b) { return b.classList.contains('is-selected'); });
    if (!anySelected) bundles[0].classList.add('is-selected');

    bundles.forEach(function (row) {
      function select() {
        bundles.forEach(function (b) { b.classList.remove('is-selected'); });
        row.classList.add('is-selected');
        syncCtaPrice();
      }
      row.addEventListener('click', select);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select();
        }
      });
    });

    syncCtaPrice();
  }

  // -----------------------------------------------------------------
  // Ajax add-to-cart for Broadcast theme (Vitasonar)
  // -----------------------------------------------------------------
  function setCtaState(btn, state) {
    var d = btn.querySelector('[data-mrlp-cta-default]');
    var l = btn.querySelector('[data-mrlp-cta-loading]');
    var s = btn.querySelector('[data-mrlp-cta-success]');
    [d, l, s].forEach(function (el) { if (el) el.hidden = true; });
    if (state === 'loading' && l) { l.hidden = false; btn.setAttribute('data-loading', 'true'); }
    else if (state === 'success' && s) { s.hidden = false; btn.removeAttribute('data-loading'); }
    else if (d) { d.hidden = false; btn.removeAttribute('data-loading'); }
  }

  function openCartDrawer(variantId, sectionsHtml) {
    // Broadcast theme — multiple strategies, in order of preference.
    // CRITICAL: only dispatch ONE open-style event. theme:cart:toggle is a
    // toggle and will close a drawer that theme:product:added just opened
    // (this caused the open-then-close flicker bug).
    var detail = { variant: { id: parseInt(variantId, 10) }, sections: sectionsHtml };

    // 1. Try the custom element's open() method (most direct)
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) { /* fall through */ }
    }

    // 2. Dispatch the show event the theme listens to (Broadcast)
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { detail: detail, bubbles: true }));

    // 3. Dispatch product:added so other theme handlers run (cart bubble update etc)
    document.dispatchEvent(new CustomEvent('theme:product:added', { detail: detail, bubbles: true }));
  }

  function refreshCartCount() {
    // Update any cart count bubbles by fetching /cart.js
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.setAttribute('data-cart-count', cart.item_count);
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* non-critical */ });
  }

  function initAtc() {
    var btn = document.querySelector('[data-mrlp-atc]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = getSelectedBundle();
      if (!sel) return;
      var variantId = sel.getAttribute('data-mrlp-variant-id');
      if (!variantId) return;

      setCtaState(btn, 'loading');

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      fd.append('sections', 'cart-drawer,api-cart-items,header');

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Add to cart failed'); });
          return r.json();
        })
        .then(function (data) {
          // Update the cart drawer's content from the section HTML the API
          // just returned. We only replace the inner content (drawer__inner
          // and drawer__footer) — replacing the whole cart-drawer element
          // breaks the custom element's own bindings.
          var sectionsHtml = (data && data.sections) || {};
          if (sectionsHtml['cart-drawer']) {
            try {
              var parsed = new DOMParser().parseFromString(sectionsHtml['cart-drawer'], 'text/html');
              var newInner = parsed.querySelector('.drawer__inner');
              var newFooter = parsed.querySelector('.drawer__footer');
              var oldInner = document.querySelector('cart-drawer .drawer__inner');
              var oldFooter = document.querySelector('cart-drawer .drawer__footer');
              if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
              if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
              // Drawer should never be in is-empty state after an add
              var drawer = document.querySelector('cart-drawer');
              if (drawer) drawer.classList.remove('is-empty');
            } catch (err) { /* fall through to event-based open */ }
          }
          if (sectionsHtml['cart-icon-bubble']) {
            try {
              var parsedBubble = new DOMParser().parseFromString(sectionsHtml['cart-icon-bubble'], 'text/html');
              var newBubble = parsedBubble.querySelector('.shopify-section') || parsedBubble.body.firstElementChild;
              var oldBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
            } catch (e) { /* non-critical */ }
          }

          refreshCartCount();
          openCartDrawer(variantId, sectionsHtml);
          setCtaState(btn, 'success');
          setTimeout(function () { setCtaState(btn, 'default'); }, 2200);
        })
        .catch(function (err) {
          console.error('[MR-LP] add-to-cart error:', err);
          setCtaState(btn, 'default');
          alert('Sorry, er ging iets mis bij het toevoegen. Probeer het opnieuw.');
        });
    });
  }

  // -----------------------------------------------------------------
  // FAQ accordion
  // -----------------------------------------------------------------
  function initFaq() {
    var items = document.querySelectorAll('[data-mrlp-faq]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-mrlp-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('[data-mrlp-faq-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // -----------------------------------------------------------------
  // Sticky bottom CTA — show after the user scrolls past the hero
  // -----------------------------------------------------------------
  function initStickyCta() {
    var sticky = document.querySelector('[data-mrlp-sticky-cta]');
    var hero = document.querySelector('.mr-sombere-lp-hero');
    var offer = document.getElementById('mrlp-offer');
    if (!sticky) return;

    function update() {
      // Hide while inside hero, hide once user reaches the offer (button
      // becomes redundant when the actual ATC is on screen).
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      var heroBottom = hero ? hero.getBoundingClientRect().bottom + scroll : 600;
      var pastHero = scroll > heroBottom - 80;

      var nearOffer = false;
      if (offer) {
        var offerTop = offer.getBoundingClientRect().top;
        // Hide once the offer section is visible in the lower half of the viewport
        nearOffer = offerTop < window.innerHeight * 0.6;
      }

      if (pastHero && !nearOffer) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // -----------------------------------------------------------------
  // Voices carousel — desktop arrows
  // -----------------------------------------------------------------
  function initVoicesCarousel() {
    var track = document.querySelector('[data-mrlp-voices-track]');
    var prev = document.querySelector('[data-mrlp-voices-prev]');
    var next = document.querySelector('[data-mrlp-voices-next]');
    if (!track) return;

    function cardScrollDelta() {
      var firstCard = track.querySelector('.mrlp-voices__card');
      if (!firstCard) return Math.max(track.clientWidth * 0.66, 280);
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '22') || 22;
      return firstCard.offsetWidth + gap;
    }

    function updateArrowState() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      // Disable prev at start, next at end (use aria-disabled so style can react)
      if (x <= 2) prev.setAttribute('aria-disabled', 'true');
      else prev.removeAttribute('aria-disabled');
      if (x >= maxScroll - 2) next.setAttribute('aria-disabled', 'true');
      else next.removeAttribute('aria-disabled');
    }

    function scrollByCards(direction) {
      var delta = cardScrollDelta() * direction;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCards(-1); });
    if (next) next.addEventListener('click', function () { scrollByCards(1); });
    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  // -----------------------------------------------------------------
  // Smooth scroll for anchor links inside our LP
  //
  // Special case for #mrlp-reviews — the Judge.me reviews block is added
  // by the user via the theme editor, so we don't know its DOM id ahead of
  // time. Instead, locate any Judge.me widget on the page (jdgm-rev-widg
  // or jdgm-widget) and scroll to its enclosing shopify-section.
  // -----------------------------------------------------------------
  function findJudgemeTarget() {
    var widget = document.querySelector(
      '.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget, [data-judgeme-product-reviews]'
    );
    if (!widget) return null;
    return widget.closest('.shopify-section') || widget;
  }

  function initSmoothScroll() {
    document.querySelectorAll('[data-mrlp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;

        var target = null;
        if (href === '#mrlp-reviews') {
          target = findJudgemeTarget();
        }
        if (!target) target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // -----------------------------------------------------------------
  // Reveal-on-scroll
  // -----------------------------------------------------------------
  function initReveal() {
    var els = document.querySelectorAll('[data-mrlp-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  // -----------------------------------------------------------------
  ready(function () {
    initGallery();
    initBundles();
    initAtc();
    initFaq();
    initVoicesCarousel();
    initStickyCta();
    initSmoothScroll();
    initReveal();
  });
})();
